import { useCallback, useEffect, useMemo, useState } from "react"
import { theme } from "~/theme"

const breakpoints = Object.assign({}, theme.media)

for (const key in breakpoints) {
  breakpoints[key as keyof typeof breakpoints] =
    theme.media[key as keyof typeof breakpoints].split("@media ")[1]
}

export function useMedia() {
  const media = useMemo(
    () =>
      Object.entries(breakpoints).map((breakpoint) =>
        window.matchMedia(breakpoint[1]),
      ),
    [],
  )

  const getMatches = useCallback(() => media.map((mql) => mql.matches), [media])
  const [matches, setMatches] = useState(getMatches)

  useEffect(() => {
    const handler = (_e: MediaQueryListEvent) => {
      setMatches(getMatches)
    }
    media.forEach((mql) => mql.addListener(handler))
    return () => media.forEach((mql) => mql.removeListener(handler))
  }, [getMatches, media])

  const matchesObject = matches.reduce(
    (previous, value, index) => ({
      ...previous,
      [Object.entries(breakpoints)[index][0]]: value,
    }),
    // Todo: make dynamicly from breakpoints
    { mobile: false, pad: false, desktop: false },
  )

  return matchesObject
}
